<template>
  <div class="ttam-image-upload-preview">
    <!-- 图标 -->
    <i class="vi-icon-ex-image" />

    <div class="ttam-image-upload-preview__body">
      <!-- 图片信息 -->
      <div class="ttam-image-upload-info">
        <div class="ttam-image-upload-info__title">
          {{ image.name }}
        </div>
        <i
          v-if="isEnd"
          data-testid="image-upload-preview-index-5v2y5o"
          class="vi-icon2-wrong-small ttam-image-upload-info__icon"
          @click="handleItemRemove"
        />
      </div>

      <!-- 进度条 -->
      <div v-if="!isEnd" class="ttam-image-upload-progress">
        <div class="ttam-image-upload-progress__total" />
        <div :style="{ width: progress + '%' }" class="ttam-image-upload-progress__completed" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: Object,
      default: () => ({}),
    },
    initDuration: {
      type: Number,
      default: 20,
    },
    min: {
      type: Number,
      default: 60,
    },
    max: {
      type: Number,
      default: 90,
    },
  },
  data() {
    return {
      isEnd: true,
      timer: null,
      progress: 0,
      duration: this.initDuration, // duration会随着进度变化而改变（控制进度条速度）
    };
  },
  watch: {
    'image.status': {
      handler(val) {
        if (val === 'uploading') {
          // 开始上传，则重置进度条，并开始模拟进度
          this.isEnd = false;
          this.progress = 0;
          this.duration = this.initDuration;
          this.startProgress();
        } else {
          this.progress = 100;
          // 延迟消失，让100%进度完成后在消失
          setTimeout(() => {
            this.isEnd = true;
          }, 100);
        }
      },
      immediate: true,
    },
  },
  methods: {
    startProgress() {
      this.timer = setTimeout(() => {
        // 已结束，则直接设置为100
        if (this.progress >= 100) {
          this.progress = 100;
          clearTimeout(this.timer);
          this.timer = null; // 清除定时器，避免导致内存溢出

          return;
        }
        this.progress++;
        if (this.progress > this.min && this.progress < this.max) {
          this.duration += 30;
        }
        if (this.progress === 99) {
          return;
        }
        this.startProgress();
      }, this.duration);
    },
    handleItemRemove() {
      this.$emit('remove', this.image);
    },
  },
};
</script>

<style lang="scss">
.ttam-image-upload-preview {
  display: flex;
  align-items: center;
  width: 400px;
  height: 48px;
  margin-top: 8px;
  padding: 0 8px 0 12px;
  border: 1px solid $--color-neutral-grey-5;
  border-radius: 4px;

  &:hover {
    border: 1px solid $--color-group1-5;
  }

  &__body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 48px;
    margin-left: 8px;

    .ttam-image-upload-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      font-size: 16px;

      &__title {
        width: 336px;
        color: $--color-group3-0;
        font-size: 14px;
        line-height: 22px;
        @extend %text-over-ellipsis;
      }

      &__icon {
        width: 16px;
        height: 16px;
        color: $--color-group3-2;

        &:hover {
          color: $--color-group3-0;
          cursor: pointer;
        }
      }
    }

    .ttam-image-upload-progress {
      position: relative;
      margin-top: 4px;

      &__total {
        width: 100%;
        border: 1px solid $--color-neutral-grey-5;
        border-radius: 4px;
      }

      &__completed {
        position: absolute;
        top: 0;
        border: 1px solid $--color-group1-5;
        border-radius: 4px;
      }
    }
  }
}
</style>
